<template lang="pug">
  .column.is-11
    article.card.table-card
      header.card-header
        p.card-header-title Despesas Aguardando Aprovação a Vencer
      .card-content.is-paddingless
        b-table(
          v-bind:data="expensesWaiting.data",
          v-bind:striped="true",
          v-bind:narrowed="false",
          v-bind:mobile-cards="false",
          v-bind:loading="expensesWaiting.isLoading",
          v-bind:row-class="getRowClass"
        )
          template(slot-scope="props")
            b-table-column(label="Nome") {{props.row.name}}
            b-table-column(label="Tipo") {{props.row.type}}
            b-table-column(label="Valor") {{props.row.value | currency}}
            b-table-column(label="Data Vencimento" v-bind:class="{'has-text-danger': props.row.due_date <= today}") {{props.row.due_date | moment('DD/MM/YYYY')}}
            b-table-column(label="Status Análise")
              b-tag(v-bind:type="statusClass[props.row.payment.status]") {{ statusLabel[props.row.payment.status] }}
            b-table-column(centered label="Gerenciar Pagamento")
              b-tooltip(label="Alterar Pagamento da Despesa" type="is-dark")
                router-link(v-bind:to="{name: 'paymentExpenseEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
            b-table-column(centered label="Gerenciar Despesa")
              b-tooltip(label="Alterar Despesa" type="is-dark")
                router-link(v-bind:to="{name: 'expenseEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
          template(slot="empty")
            section.section
              .content.has-text-grey.has-text-centered
                p
                  b-icon(icon="sentiment_very_dissatisfied", size="is-large")
                p Nenhum dado.
</template>

<script>
  import DataNotification from './DataNotification'

  import ExpenseService from '@/services/expense.js'
  const {statusLabel, statusClass} = ExpenseService

  export default {
    name: 'ExpensesWaiting',
    components: {DataNotification},
    data () {
      return {
        today: this.$moment().startOf('day').toISOString(),
        expensesWaiting: {isLoading: false, data: []},
        statusLabel,
        statusClass
      }
    },
    async created () {
      this.fetchExpensesWaiting()
    },
    methods: {
      getRowClass (row) {
        if (row.due_date <= this.today) return 'is-danger'
      },
      async fetchExpensesWaiting (params) {
        let query = {payment: {paid: false, status: {$in: ['waiting', 'provision']}}, limit: 20, sort: {due_date: 'asc'}}
        query = Object.assign(query, params)
        this.expensesWaiting.isLoading = true
        const response = await ExpenseService.query(query)
        this.expensesWaiting.isLoading = false
        this.expensesWaiting.data = response.body.expenses

        console.log(this.expensesWaiting)
      }
    }
  }
</script>

<style lang="sass" scoped>
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// ExpensesWaiting.vue?71a0a91e